const handleWorkshopLinkClick = (dispatchSetActiveWorkshop) => (e) => {
  const anchor = e.target.closest('a');
  if (!anchor) return;
  const href = anchor.getAttribute('href') || '';
  const match = href.match(/[?&]workshopId=(\d+)/);
  const moduleMatch = /[?&]module=Workshops/.test(href);
  if (match && moduleMatch) {
    e.preventDefault();
    dispatchSetActiveWorkshop(match[1]);
  }
};

export default handleWorkshopLinkClick;
